(ns practitest.frontend.tests.link-testsets
  (:require 
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.common.i18n :refer [get-translation] :as i18n]
    [practitest.frontend.common.re-frame :refer [partial-dispatch partial-subscribe]]
    [practitest.frontend.components.grid.events :as grid.events]
    [practitest.frontend.components.grid.localstorage :as grid-storage]
    [practitest.frontend.components.grid.subs :as grid.subs]
    [practitest.frontend.components2.add-entities :as add-entities]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.components2.grid.fields :refer [transform-fields]]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.tests.events :as tests-events]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

(def current-entity :test)
(def grid-entity :testset)
(def linked-entities-state-key :link-testsets-state)


(defn link-entities-dialog-options [grid-state]
  {:show? (re-frame/subscribe [::grid.subs/show-link-entities-modal? current-entity linked-entities-state-key])
   :hide! #(re-frame/dispatch [::common-events/toggle-link-entities-modal current-entity linked-entities-state-key])
   :show-views? (re-frame/subscribe [::grid.subs/link-entities-show-views? current-entity linked-entities-state-key])
   :current-filter-selected (re-frame/subscribe [::grid.subs/link-entities-current-filter-selected current-entity linked-entities-state-key])
   :set-current-filter (partial-dispatch [::common-events/set-current-filter grid-entity linked-entities-state-key
                                          ::common-events/fetch-entity-list])
   :set-current-folder (partial-dispatch [::common-events/set-current-folder grid-entity linked-entities-state-key
                                           ::common-events/fetch-entity-list-by-folder])
   :on-query-changed (partial-dispatch [::on-linked-entites-query-changed grid-entity])
   :grid-state grid-state
   :loading? (re-frame/subscribe [::subs/progress? ::common-events/fetch-entity-list])
   :module "TestSet"
   :title                 (get-translation "test.button.add-test-to-testset" "Add to Test Set")
   :table-id              (str (:id @(re-frame/subscribe [::subs/current-project]))
                               "-linked-entites-testsets-grid")
   :data                  (re-frame/subscribe [::linked-entites-data])
   :columns               (re-frame/subscribe [::grid.subs/columns [current-entity :tests-link-testsets-state]])

   :selected-entities     (re-frame/subscribe [::grid.subs/selection [current-entity linked-entities-state-key]])
   :selected?             #(re-frame/subscribe [::grid.subs/selected? [current-entity linked-entities-state-key] %])
   :all-selected?         #(re-frame/subscribe [::grid.subs/all-selected? [current-entity linked-entities-state-key] %])
   :toggle-selection      (partial-dispatch [::grid.events/toggle-selection [current-entity linked-entities-state-key]])
   :toggle-selection-page (partial-dispatch [::grid.events/toggle-selection-page [current-entity linked-entities-state-key]])
   :current-page          (re-frame/subscribe [::grid.subs/entities-current-page current-entity linked-entities-state-key])
   :total-count           (re-frame/subscribe [::grid.subs/entities-total-count current-entity linked-entities-state-key])
   :get-field-props       (partial-subscribe [::forms/field-props :testset])
   :full-data?            (re-frame/subscribe [::grid.subs/entities-full-data? current-entity linked-entities-state-key])
   :on-add-entities (partial-dispatch [::tests-events/link-tests-to-testsets current-entity linked-entities-state-key])
   :add-entities-button-label (get-translation "testset.link.add-selected"
                                               "Add selected %{n} Testsets")})

(defn linked-entities-dialog []
  (let [container-ref (atom nil)
        grid-state (reagent/atom {:module "TestSet"})]
    (fn [_]
      [:div
       {:ref #(reset! container-ref %)}
       [add-entities/add-entities-dialog
        container-ref
        (link-entities-dialog-options grid-state)]])))

(re-frame/reg-sub
  ::linked-entites-data
  (fn [db [_]]
    (get-in db [:entity current-entity linked-entities-state-key :data])))

(re-frame/reg-event-fx
  ::on-linked-entites-query-changed
  (fn [_ [_ _ grid-query]]
    (re-frame/dispatch [::common-events/fetch-entity-list grid-entity linked-entities-state-key grid-query])))

(defn show-linked-entities-dialog []
  (re-frame/dispatch [::common-events/toggle-link-entities-modal
                      grid-entity
                      linked-entities-state-key
                      ::common-events/fetch-entity-list
                      (reagent/partial grid-storage/load-per-page current-entity)]))

(defmethod grid.subs/columns :tests-link-testsets-state [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
    [{:type           :display_id
      :field          :display_id
      :default-width  80
      :default-show?  true
      :autofilter?    true
      :header         (get-translation "generic.label.id" "ID")}
     {:type           :nc-name
      :field          :name
      :default-width  250
      :autofilter?    true
      :header         (get-translation "generic.label.name" "Name")}
     {:type           :milestone
      :field          :milestone_id
      :default-width  80
      :default-show?  true
      :autofilter?    true
      :header         (get-translation "milestone.singular" "Milestone")}
     {:type           :text
      :field          :instances_count
      :default-width  120
      :default-show?  false
      :autofilter?    true
      :header         (get-translation "instance.instances-count" "Instances Count")}]
    (transform-fields [:run_status :last_run :assigned_to]
                      (dissoc (:testset entity-fields) :description :milestone_id)
                      fields users groups folders)))
